import React from "react";
import Barcode from "react-barcode";
const BarCode = props => {
    let { label, labelMandate, ...rest } = props;
    return (
        <div className="barcode-layout">
            <div className="barcode-label">
                {label || ""}
                {labelMandate && label ? <span className="required-input">*</span> : null}
            </div>
            <Barcode
                {...rest}
                lineColor="#16325c"
                width={2}
                height={25}
                textAlign="left"
                format="CODE128"
                margin={0}
                textMargin={8}
                marginTop={8}
            />
            <div className="barcode-border-bottom"></div>
        </div>
    );
};

export default BarCode;
